/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelSmsControl.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/sms-control";

export class AutogenModelSmsControl<RowType extends ModelRow> extends Endpoint<RowType, RowSmsControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowSmsControl extends ModelRow<RowSmsControlFields> {
	constructor(values?: Partial<RowSmsControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowSmsControlFields {
	account_id: string;
	account_password: string;
	account_username: string;
	api_secret: string;
	api_token: string;
	api_version: number;
	application_id: string;
	callback_url: string;
	company_id: string;
	id: string;
	is_active: string;
	location_id: number;
	return_messages_last_update: Date;
	sender_id: string;
	site_id: number;
	vendor_id: string;
	web_password: string;
	web_username: string;
}

